import  { useState } from 'react'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import Loader from '../../Loader/buttonLoad';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../../../components/footer';
import { useUserSwapmasterHis } from './api/api';

const SwapIncome = () => {
    const [page, setPage] = useState(0);
    const navigate = useNavigate()
    const rowsPerPage = 10;

    const { data: swapHistoryList, isFetching } = useUserSwapmasterHis({
        page,
        size: rowsPerPage,
        type: "swaptoMaster",
    })

    const totalPages = Math.ceil(swapHistoryList?.count / rowsPerPage);
    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPage(newPage);
        }
    };



    return (
        <div>
            <div className="mainContent">
                {(isFetching) && <Loader />}
                <div className="pageContent def-py-30">

                    <div className='container'>
                        <div className="appPagetitle d-flex g-10 align-items-center">
                            <button className='btn btnBack' onClick={() => navigate('/master-wallet')}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button>
                            <span>Swap Income</span>
                        </div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 px-0 pb-2 cardbg">
                                    <div className="cardHeader border-bottom-0 px-4 pb-0">
                                        <div>
                                            <div className="px-4 mb-3">
                                                
                                            </div>
                                            <div className='table-responsive mb-3'>
                                                <table className='table myapptable table-hover table-borderless mb-0'>
                                                    <thead>
                                                        <tr>
                                                            <th className='pl-4'>S.No</th>
                                                            <th className='text-nowrap'>Type</th>
                                                            <th className='text-nowrap'>To Master Wallet</th>
                                                            <th className='text-right pr-4'>Date & Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {swapHistoryList?.count > 0 ? (swapHistoryList?.data?.map((v,i) =>
                                                            <tr key={v?._id}>
                                                                <td className='pl-4'>{page * rowsPerPage + (i + 1)}</td>

                                                                <td >Swap</td>
                                                                <td >{v?.amount}<span className="text-white-60"> USDT</span></td>
                                                                <td className='text-right pr-4'>{moment(v?.createdAt).format("DD/MM/YYYY | hh:mm A")}</td>
                                                            </tr>)) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">No data found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="px-4">
                                                <div className='row'>
                                                    <div className='col-lg-12'>
                                                        <Pagination aria-label="Page navigation" className='customPagination'>
                                                            <PaginationItem disabled={page === 0}>
                                                                <PaginationLink previous href="#" onClick={() => handlePageChange(page - 1)} className='prevbtn'>
                                                                    <i className='bi bi-arrow-left align-bottom'></i> Previous
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                            <span className='number'>

                                                                {page < 3 ? (
                                                                    Array.from({ length: Math.min(3, totalPages) }, (_, index) => (
                                                                        <PaginationItem key={index} active={index === page} className={`${index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                            <PaginationLink href="#" onClick={() => handlePageChange(index)}>
                                                                                {index + 1}
                                                                            </PaginationLink>
                                                                        </PaginationItem>
                                                                    ))
                                                                ) : (
                                                                    <>
                                                                        {page > 0 && (
                                                                            <PaginationItem key={0} className="customPagination">
                                                                                <PaginationLink href="#" onClick={() => handlePageChange(0)}>
                                                                                    1
                                                                                </PaginationLink>
                                                                            </PaginationItem>
                                                                        )}

                                                                        {page > 1 && (
                                                                            <PaginationItem disabled>
                                                                                <PaginationLink href="#">...</PaginationLink>
                                                                            </PaginationItem>
                                                                        )}

                                                                        {Array.from({ length: 3 }, (_, index) => (
                                                                            <PaginationItem key={page - 1 + index} active={page - 1 + index === page} className={`${page - 1 + index === page ? 'customPagination active' : 'customPagination'}`}>
                                                                                <PaginationLink href="#" onClick={() => handlePageChange(page - 1 + index)}>
                                                                                    {page - 1 + index + 1}
                                                                                </PaginationLink>
                                                                            </PaginationItem>
                                                                        ))}

                                                                        {page < totalPages - 2 && (
                                                                            <PaginationItem disabled>
                                                                                <PaginationLink href="#">...</PaginationLink>
                                                                            </PaginationItem>
                                                                        )}

                                                                        {page < totalPages - 1 && (
                                                                            <PaginationItem key={totalPages - 1} className="customPagination">
                                                                                <PaginationLink href="#" onClick={() => handlePageChange(totalPages - 1)}>
                                                                                    {totalPages}
                                                                                </PaginationLink>
                                                                            </PaginationItem>
                                                                        )}
                                                                    </>
                                                                )}

                                                            </span>

                                                            <PaginationItem disabled={page === totalPages - 1}>
                                                                <PaginationLink next href="#" onClick={() => handlePageChange(page + 1)} className='nextbtn'>
                                                                    Next <i className='bi bi-arrow-right align-bottom'></i>
                                                                </PaginationLink>
                                                            </PaginationItem>
                                                        </Pagination>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default SwapIncome
